import { Modal as MuiModal } from "@material-ui/core";
import React from "react";
export interface ModalProps {
    open: boolean;
    children: React.ReactElement;
    className?: string;
}
export function Modal({ open, className, children }: ModalProps) {
    return (<MuiModal open={open} className={className}>
            {children}
        </MuiModal>);
}
